<template>
  <div id="background" @click="full()">
    <div class="title">{{msg}}</div>
    <!--img class="image1" src="https://img1.baidu.com/it/u=3303981320,1355171730&fm=26&fmt=auto"/>
    <div class="chat1">{{world1}}</div>
    <img class="image2" src="https://img2.baidu.com/it/u=1960058469,2576593478&fm=26&fmt=auto"/>
    <div class="chat2">{{world2}}</div-->


    <img class="image-big" src="https://img2.baidu.com/it/u=1960058469,2576593478&fm=26&fmt=auto"/>
    <div class="chat-big">{{world2}}</div>
  </div>
</template>

<script>
  export default {
    name: 'Chat',
    data () {
      return {
        baseUrl: 'http://goc6.com',//''process.env.baseUrl'',//process
        msg: "大扫除",
        world1: "",
        world2: "",
        begin: "开始",
        over: "结束",
        interval: null,
        startTime: 0,
        endTime: 0,
        title: "",
        current: "end",
        colors: "blue",
        selectStyle: "background: #7b9ce1; color: #FFF;",
        colorStyleMap: {
          green : "background: #72b362; color: #FFF;",
          blue : "background: #7b9ce1; color: #FFF;",
          red : "background: #bd6d6c; color: #FFF;"
        }
      }
    },
    mounted () {
      this.getWorld();
    },
    methods: {

      full(){
        let element = document.getElementById('background');//设置后就是   id==con_lf_top_div 的容器全屏
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      },
      getWorld (){
        const url = "https://api.ixiaowai.cn/ylapi/index.php";
        //"https://www.inqingdao.cn/hitokoto/";
        //http://api.eei8.cn/say/api.php
        let that = this;
        this.$axios.get(url, {
        },{headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }}).then(function (response) {
          that.world1 = response.data || "";
        })
        this.$axios.get(url, {
        },{headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }}).then(function (response) {
          that.world2 = response.data || "";
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  html, body { height: 100%; width: 100%;Font-size: 25%}
  #background{
    background-image: url("https://img2.baidu.com/it/u=113939220,3899877759&fm=26&fmt=auto");
    height: 100%;
    width: 100%;
    position: absolute;
    background-size:cover;
    background-position: center;
    /*background-attachment: fixed;
    background-repeat: no-repeat;
    background-size: 100% 100%;*/
  }



  /*{ "position": "absolute", "width":"100%", "height":"100%", "background-size": "100% 100%", "background-repeat": "no-repeat", "background-image": "url('http://4et.oss-cn-beijing.aliyuncs.com/4et/item/61/bg.png')" }
*/
  .title{
    opacity:0.8;
    border-radius:10px 0;
    background: #FFF;
    position: absolute;
    width: 80%;
    top: 16%;
    left: 10%;
    color: rgb(61, 50, 39);
    font-size: 3rem;
    font-weight: bold;
    text-align: center;
  }
  .image1{
    position: absolute;
    width: 15%;
    top: 35%;
    left: 5%;
  }
  .chat1 {
    opacity:0.8;
    background: #FFF;
    position: absolute;
    width: 60%;
    top: 35%;
    left: 25%;
    color: rgb(61, 50, 39);
    font-size: 1rem;
    font-weight: bold;
    text-align: center;
    border-radius:10px;
    box-shadow: 0 5px 7px -1px rgba(51, 51, 51, 0.23);
  }
  .image2{
    position: absolute;
    width: 15%;
    top: 55%;
    left: 75%;
  }
  .chat2 {
    opacity:0.8;
    background: #FFF;
    position: absolute;
    width: 60%;
    top: 55%;
    left: 10%;
    color: rgb(61, 50, 39);
    font-size: 1rem;
    font-weight: bold;
    text-align: center;
    border-radius:10px;
    box-shadow: 0 5px 7px -1px rgba(51, 51, 51, 0.23);
  }

  .image-big{
    position: absolute;
    width: 15%;
    top: 65%;
    left: 5%;
  }


  .chat-big {
    opacity:0.8;
    background: #FFF;
    position: absolute;
    width: 60%;
    top: 65%;
    left: 25%;
    color: rgb(61, 50, 39);
    font-size: 1rem;
    font-weight: bold;
    text-align: center;
    border-radius:10px;
    box-shadow: 0 5px 7px -1px rgba(51, 51, 51, 0.23);
  }
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/game/shipin/Chat.vue